module.exports = __webpack_public_path__ + "static/media/katariina-sommerschield-quote.a5c9e17c.png";